import { render, staticRenderFns } from "./SelectVehicle.vue?vue&type=template&id=673f9e3f&scoped=true&"
import script from "./SelectVehicle.vue?vue&type=script&lang=js&"
export * from "./SelectVehicle.vue?vue&type=script&lang=js&"
import style0 from "./SelectVehicle.vue?vue&type=style&index=0&id=673f9e3f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673f9e3f",
  null
  
)

export default component.exports